const mutations = {
  LOGIN(state, payload) {
    state.user.username = payload.username
    state.user.token = payload.token
    state.user.isAuth = true
  },
  LOGOUT(state) {
    state.user.username = null
    state.user.token = null
    state.user.isAuth = false
    state.objects = null
    state.redirects = null
    state.bindings = null
    state.templates = null
    state.vouchers = null
  },
  OBJECTS_GET(state, objects) {
    state.objects = objects
  },
  REDIRECTS_GET(state, redirects) {
    state.redirects = redirects
  },
  TEMPLATES_GET(state, templates) {
    state.templates = templates
  },
  BINDINGS_GET(state, bindings) {
    state.bindings = bindings
  },
  TEMPLATE_SET(state, data) {
    const {
      id,
      mode,
      title,
      content_title,
      content,
      horz_bg_16x9,
      logo,
      button_color,
      button_txt_color,
    } = data
    state.template = {
      id: id,
      mode: mode,
      title: title,
      content_title: content_title,
      content: content,
      horz_bg_16x9: horz_bg_16x9,
      logo: logo,
      button_color: button_color,
      button_txt_color: button_txt_color,
    }
  },
  TEMPLATE_STEP_SET(state, stepNumber) {
    state.templateStep = stepNumber
  },
  MODAL_IS_SHOW_SET(state, bool) {
    state.isShowModal = bool
  },
  VOUCHERS_GET(state, payload) {
    state.vouchers = payload
  },
}

export default mutations



// WEBPACK FOOTER //
// ./src/store/mutations.js